import React from 'react';
import App from 'next/app';
import Script from 'next/script';
import { ApolloProvider } from '@apollo/client';
import { ResponsiveImageProvider } from '@blaze-cms/image-cdn-react';
import { withBlaze } from '@blaze-cms/nextjs-tools';
import { EcommerceContextWrapper } from '@blaze-cms/ecommerce-context';
import buildConfig from '../blaze.config';
import IndexPage from '../components/IndexPage';
import { RESPONSIVE_IMAGE_CONFIG } from '../constants';

import '../styles/sass/_fonts.scss';
import '../styles/tailwind-base.css';
import '../styles/sass/main.scss';
import '../styles/globals.css';

class MyApp extends App {
  render() {
    const { Component, pageProps, apolloClient, router } = this.props;

    return (
      <>
        <Script id="gtm-blaze_after_interactive_event" strategy="afterInteractive">{`
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
          'event': 'blaze_after_interactive'
          });
        `}</Script>
        <ApolloProvider client={apolloClient}>
          <IndexPage />
          <ResponsiveImageProvider config={RESPONSIVE_IMAGE_CONFIG}>
            <EcommerceContextWrapper disableBillingAddressUpdates>
              <div className="site-container">
                <Component {...pageProps} router={router} />
              </div>
            </EcommerceContextWrapper>
          </ResponsiveImageProvider>
        </ApolloProvider>
      </>
    );
  }
}

export default withBlaze(MyApp, buildConfig);
